// extracted by mini-css-extract-plugin
export default {"root":"SignStatus_root__3NQHC","state":"SignStatus_state__c2PQc","doing":"SignStatus_doing__9ktaz","done":"SignStatus_done__fGPPg"};